import { gql } from '@apollo/client';
const GET_SPECIFICATION_CONFIRMATION_PROBLEMS = gql `
  query GetSpecificationConfirmationProblems($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        productionTimeMinutes
        confirmationProblems {
          id
        }
        estimatedCostCalculationProblems {
          id
          blocksSpecificationConfirmation
        }
      }
    }
  }
`;
export default GET_SPECIFICATION_CONFIRMATION_PROBLEMS;
